import React from "react";
import { useSelector , useDispatch } from "react-redux";


import { initialiseLeadmemo , modifyDisplaymodal} from "../../state/redux";


import './ButtonSouscrire.scss' ;
function ButtonSouscrire(){
    const dispatch = useDispatch() ;
    const lead = useSelector(state=>state.lead.leadactu) ;

    const nbetapes = ['sign_coord','sign_formule','sign_docs','sign_bulletin','sign_fic'].filter(x=>lead[x]===2).length ;

    const click = async()=>{  dispatch(initialiseLeadmemo(lead)) ;  dispatch(modifyDisplaymodal('mod_contratwin')) ;}
 
    return(<div className="boutonsouscrire" onClick={click} >
                <div className="boutonsouscrire_texte" >{nbetapes===7?'Gagné':'Souscrire'} </div>
                <div  className="boutonsouscrire_avancement_container">
                     <div  style={{height:'100%',width: `${nbetapes*100/5}%`,background:'#12B76A'}}  >  </div>  
                </div>
            </div>);
}     


export default ButtonSouscrire